import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import AllocateSubcaseService from './allocate-subcase-modal.service';

export default angular
  .module('verifyApp.allocate-subcase-modal', [uiRouter, uiBootstrap])
  .service('AllocateSubcaseService', AllocateSubcaseService)
  .name;



// WEBPACK FOOTER //
// ./client/components/allocate-subcase-modal/index.js